/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseBoolData } from './genericApiResponseBoolData';
import type { GenericApiResponseBoolMessage } from './genericApiResponseBoolMessage';
import type { GenericApiResponseBoolPagination } from './genericApiResponseBoolPagination';
import type { GenericApiResponseBoolError } from './genericApiResponseBoolError';

export interface GenericApiResponseBool {
  data?: GenericApiResponseBoolData;
  message?: GenericApiResponseBoolMessage;
  pagination?: GenericApiResponseBoolPagination;
  error?: GenericApiResponseBoolError;
  statusCode?: number;
}
